import { Directive } from '@angular/core';
@Directive({
  selector: '[fAlertsContainer]'
})
export class AlertsContainerDirective {}
